(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('MedRouteDetailController', MedRouteDetailController);

    MedRouteDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'MedRoute', 'Medication', 'Corporation'];

    function MedRouteDetailController($scope, $rootScope, $stateParams, previousState, entity, MedRoute, Medication, Corporation) {
        var vm = this;

        vm.medRoute = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('dialysisApp:medRouteUpdate', function(event, result) {
            vm.medRoute = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
